
<div class="showcase-view">
  <ftu-block
    dismiss-key="showcase"
    icon="travel_explore"
    title="This is the Showcase"
    description="The Showcase is a place where you can browse collections of other members in Card Ladder PRO. Search for any card, use the filters to narrow down your results, and reach out to the owner to see if the card is for sale."
  />

  <page-header title="Showcase">
    <template #actions>
      <icon-button
        icon="add_circle"
        @click="handleShare"
      />
    </template>
  </page-header>

  <template>
    <div class="tabs">
      <tab :active="display === 'cards'" @click="display = 'cards'">
        Cards
      </tab>

      <tab :active="display === 'collections'" @click="display = 'collections'">
        Collections
      </tab>

      <tab :active="display === 'favorites'" @click="display = 'favorites'">
        Favorites
      </tab>
    </div>

    <div class="wrapper">
      <showcase-cards-view v-if="display === 'cards'" :key="0" />
      <showcase-collections-view v-if="display === 'collections'" />
      <showcase-cards-view v-if="display === 'favorites'" :key="1" favorites />
    </div>
  </template>
</div>
